import React, { useContext } from 'react';
import OptionsButton from './OptionsButton';
import PropTypes from 'prop-types';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';

const WardrobeOptionsButtons = props => {
  const { editSegment, changeConfiguratorMode } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);

  const cornerIndex = wardrobesConfigs.findIndex(config => config.is_corner === true);

  const cnt = wardrobesConfigs.length;
  const shiftOptions = cnt > 1;
  const deleteOptions = cnt > 1;
  const deleteOptions2 =
    activeWardrobe === cornerIndex
      ? wardrobesConfigs[cornerIndex + 1] && wardrobesConfigs[cornerIndex - 1]
        ? wardrobesConfigs[cornerIndex + 1].dimensions.z === 45 ||
          wardrobesConfigs[cornerIndex - 1].dimensions.z === 45
          ? false
          : true
        : true
      : true;

  const duplicateOptions = cnt < 5 && wardrobesConfigs[activeWardrobe].is_corner === false;

  const setSegment = action => {
    editSegment(action);
  };

  return (
    <div className="options">
      <OptionsButton
        clickFunction={setSegment}
        action="edit"
        text="Konfiguruj"
        icon="configuration"
      />
      {shiftOptions && (
        <OptionsButton
          clickFunction={setSegment}
          action="shift"
          text="Przenieś"
          icon="directions"
          goToMode={10}
          changeConfiguratorMode={changeConfiguratorMode}
        />
      )}
      {duplicateOptions && (
        <OptionsButton
          clickFunction={setSegment}
          action="duplicate"
          text="Duplikuj"
          icon="duplicate"
          goToMode={8}
          changeConfiguratorMode={changeConfiguratorMode}
        />
      )}
      {deleteOptions && deleteOptions2 && (
        <OptionsButton
          clickFunction={setSegment}
          action="delete"
          text="Usuń"
          icon="trash"
          goToMode={8}
          changeConfiguratorMode={changeConfiguratorMode}
        />
      )}
    </div>
  );
};

WardrobeOptionsButtons.propTypes = {
  editSegment: PropTypes.func.isRequired,
};

export default WardrobeOptionsButtons;
